import React, { useState } from 'react';
import { Image, TouchableOpacity } from 'react-native';
import { ImageBackground, Text } from 'react-native-web';
import { img_send_button_setting } from '../../../utils/ImagesManagementUtils';

const ArrowShapedButton = ({
  title,
  onPress,
  darkTheme,
  background,
}) => {
  const [width, setWidth] = useState(false);
  const [height, setHeight] = useState(false);

  Image.getSize(background, (width1, height1) => {
    setWidth(width1);
    setHeight(height1);
  });
  const myStyles = {
    container: {
      width,
      height,
      backgroundImage: background,
    },
    title: {
      margin: 'auto',
      fontFamily: 'Quicksand-Bold',
      fontSize: 18,
      color: darkTheme && 'white',
    },
    image: {

      position: 'absolute',
      width,
      height,
    },
    imageSetting: {
      margin: 'auto',
      width: 30,
      height: 30,
    },
  };
  return (
    <TouchableOpacity
      style={myStyles.container}
      onPress={onPress}
      disabled={!onPress}
    >
      <ImageBackground
        source={background}
        resizeMode="cover"
        style={myStyles.image}
      >
        {title ? (
          <Text style={myStyles.title}>
            {title}
          </Text>
        )
          : (
            <Image
              style={myStyles.imageSetting}
              source={img_send_button_setting}
            />
          )}
      </ImageBackground>
    </TouchableOpacity>
  );
};

export default ArrowShapedButton;
